// removed by extract-text-webpack-plugin
module.exports = {"errorPage":"_3rDA3"};


//////////////////
// WEBPACK FOOTER
// ../source/components/ErrorBoundary/styles.css
// module id = 815
// module chunks = 26